export const InvoiceStates = Object.freeze({
	UNVERIFIED: "unverified",
	VERIFIED: "verified",
	EXCLUDED: "excluded",
	HISTORY: "history",
	CANCELED: "canceled",
	ERROR: "error",
	NOTIFICATION_SENT: "notification_sent",
	ALL: "all", // ! Only for ARO and Sales, this states it's not a type for the invoices.
});

export const InvoicesTypesColor = {
	unverified: "orange",
	verified: "green",
	excluded: "yellow",
	history: "blue",
	canceled: "gray",
	error: "red",
	notification_sent: "purple",
	all: "black",
};

export const InvoicesTypes = {
	unverified: "Sin Verificar",
	verified: "Verificada",
	excluded: "Excluída",
	history: "Historia",
	canceled: "Anulada",
	error: "Error",
	notification_sent: "Notification Sent",
	all: "Todos",
};